<template>
  <div>
    <div
      v-if="!loading || tableData.length === 0"
      class="flex flex-col justify-center items-center h-full mt-5"
    >
      <el-empty :image-size="70" description="No Data"></el-empty>
    </div>
    <div class="" v-else>
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Flexi Hours",
  data() {
    return {
      loading: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        { field: "Day", key: "a", title: "Day" },
        { field: "WorkingHours", key: "b", title: "Working Hours" },

        {
          field: "WorkType",
          key: "x",
          title: "Work Type",
        },
        { field: "Condition", key: "d", title: "Condition" },
        { field: "Status", key: "e", title: "Status" },
      ],
      tableData: [],
    };
  },
};
</script>

<style scoped></style>
